import useReadAuthState from './useReadAuthState';

const useStandAloneAuth = () => {
  const status = useReadAuthState();

  return {
    isResolved: status !== 'pending',
    isAuthorized: status === 'authorized',
  };
};

export default useStandAloneAuth;
